export const formatDate = (
  date: Date,
  timeFormat: "12h" | "24h",
  short: boolean = false,
): string => {
  return date.toLocaleDateString(timeFormat === "24h" ? "en-GB" : "en-US", {
    weekday: short ? "long" : "short", // opposite logic here to compensate
    month: "short",
    day: "numeric",
    year: short ? undefined : "numeric",
    hour: short ? undefined : "2-digit",
    minute: short ? undefined : "2-digit",
  });
};
